// src/components/formBuilder/SkeletonList.jsx
import React from "react";
import { Box, Skeleton, Stack } from "@mui/material";

export default function SkeletonList({ rows = 6 }) {
  return (
    <Stack spacing={1.5} sx={{ mt: 1 }}>
      {Array.from({ length: rows }).map((_, i) => (
        <Box key={i} sx={{ p: 1 }}>
          <Skeleton variant="text" width="60%" height={22} />
          <Skeleton variant="text" width="40%" height={18} />
          <Skeleton variant="rectangular" height={1} sx={{ mt: 1 }} />
        </Box>
      ))}
    </Stack>
  );
}